import { useSyncExternalStore } from "react";

import { type ActingClinic, getActingClinic, subscribeActingClinic } from "../api/session";

/**
 * The clinic a superadmin is currently standing in, if any.
 *
 * `useSyncExternalStore` rather than a context: the value lives in `session.ts`
 * alongside the access token it travels with, and this is the read side of
 * that same module-level store — no provider to wrap the app in for one banner.
 */
export function useActingClinic(): ActingClinic | null {
  return useSyncExternalStore(subscribeActingClinic, getActingClinic);
}
